import HomerPage from "page/index";
import "./App.css";

function App() {
  return (
    <div>
      <HomerPage />
    </div>
  );
}

export default App;
